<h3 class="title">
  <span class="basic-flex-container">
    Template file
    @if (!templateValid) {
      <mat-icon
        class="error-circle"
        fontIcon="error_outline"
        [matTooltip]="'Please ensure you have a valid template file.'"
      ></mat-icon>
    }
  </span>
</h3>
<app-upload-file
  [formGroup]="formGroup"
  [workflowConfigId]="workflowConfigId"
  [tooltip]="'Template file'"
  [acceptableFileTypes]="['.docx']"
  [getFileInfo]="getInfo.bind(this)"
  [fileValid]="templateValid"
  (fileNameChange)="onDocxFileNameChange($event)"
  >
</app-upload-file>
